import { Tooltip as TooltipAD } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { resolveClassNames } from '../utils';

export type TooltipProperties = Omit<ComponentProps<typeof TooltipAD>, 'css'>;

import styles from './tooltip.module.css';

const Tooltip = ({ children, classNames, title, ...rest }: TooltipProperties) => {
  const { t } = useTranslation();

  return (
    <TooltipAD
      classNames={resolveClassNames(classNames, (resolvedClassNames) => ({
        ...resolvedClassNames,
        container: cn(resolvedClassNames?.container, styles.container),
      }))}
      title={typeof title === 'string' ? t(title) : title}
      {...rest}
    >
      {typeof children === 'string' ? t(children) : children}
    </TooltipAD>
  );
};

export default Tooltip;
